// extracted by mini-css-extract-plugin
export var numpadContainer = "_o7-1";
export var phoneButton = "_o7-0";